import { render, staticRenderFns } from "./asgTable.vue?vue&type=template&id=716d56a0&scoped=true"
import script from "./asgTable.vue?vue&type=script&lang=js"
export * from "./asgTable.vue?vue&type=script&lang=js"
import style0 from "./asgTable.vue?vue&type=style&index=0&id=716d56a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d56a0",
  null
  
)

export default component.exports